import { supabase } from '../../client';

export interface ReferralEvent {
  id: number;
  name: string;
  end_at: string;
  reward_multiplier: number;
  max_referees: number | null;
  is_full: boolean;
}

/**
 * 지금 진행 중인 초대 이벤트(없으면 null). 실패는 throw — 호출부가 "이벤트 없음"과 장애를 구분해야 한다
 * (장애를 null로 삼키면 이벤트 대상자에게 기본 보상을 확정 표시하게 됨).
 * 노출 판단 전용. 실제 당첨 판정은 admin-referral-approve 엣지.
 */
export async function getActiveReferralEvent(): Promise<ReferralEvent | null> {
  const { data, error } = await supabase.rpc('get_active_referral_event');
  if (error) throw error;
  return (data as ReferralEvent[] | null)?.[0] ?? null;
}
